import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Always scroll to top on initial load. After that, only scroll to top
    // on PUSH (forward navigation via link clicks). On POP (back/forward),
    // skip — the page's own restoration logic handles it. Without this,
    // ScrollToTop overrides restored scroll position on every Back press.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      window.scrollTo(0, 0);
      return;
    }
    if (navType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
}

export default ScrollToTop;
